import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Eye,
  Clock,
  ScanFace,
  Users,
  Info,
} from "lucide-react";

const MAP = {
  match: { label: "MATCH", cls: "bg-emerald-600 text-white hover:bg-emerald-600", Icon: CheckCircle2 },
  mismatch: { label: "MISMATCH", cls: "bg-red-600 text-white hover:bg-red-600", Icon: XCircle },
  no_face: { label: "NO FACE", cls: "bg-slate-700 text-white hover:bg-slate-700", Icon: ScanFace },
  multi_face: { label: "MULTI FACE", cls: "bg-amber-500 text-slate-950 hover:bg-amber-500", Icon: Users },
  skipped: { label: "SKIPPED", cls: "bg-slate-400 text-slate-950 hover:bg-slate-400", Icon: Eye },
  pending: { label: "PENDING", cls: "bg-amber-500 text-slate-950 hover:bg-amber-500", Icon: Clock },
  pending_validation: { label: "PENDING", cls: "bg-amber-500 text-slate-950 hover:bg-amber-500", Icon: Clock },
  validated: { label: "VALIDATED", cls: "bg-emerald-600 text-white hover:bg-emerald-600", Icon: CheckCircle2 },
  marked: { label: "MARKED", cls: "bg-emerald-600 text-white hover:bg-emerald-600", Icon: CheckCircle2 },
  rejected: { label: "REJECTED", cls: "bg-red-600 text-white hover:bg-red-600", Icon: XCircle },
  outside: { label: "OUTSIDE GEOFENCE", cls: "bg-amber-500 text-slate-950 hover:bg-amber-500", Icon: AlertTriangle },
  inside: { label: "INSIDE GEOFENCE", cls: "bg-emerald-600 text-white hover:bg-emerald-600", Icon: CheckCircle2 },
  info: { label: "INFO", cls: "bg-sky-600 text-white hover:bg-sky-600", Icon: Info },
};

export function StatusBadge({ kind, label, className = "", iconOnly = false, testId }) {
  const cfg = MAP[kind] || MAP.info;
  const { Icon } = cfg;
  return (
    <Badge className={`rounded-full px-2.5 py-1 text-[11px] tracking-wide font-semibold gap-1 ${cfg.cls} ${className}`} data-testid={testId}>
      <Icon className="h-3.5 w-3.5" />
      {!iconOnly && <span>{label || cfg.label}</span>}
    </Badge>
  );
}
